import React, { useState } from 'react';
import LogoSvg from '../../../../../prod/images/logo-type.svg?react';
import MenuSvg from '../../../../../prod/images/menu.svg?react';
import SearchRedesignSvg from '../../../../../prod/images/redesign/search.svg?react';
import CrossSvg from '../../../../../prod/images/cross.svg?react';
import MegaMenuMobile from './MegaMenuMobile';
import useMegaMenuMobileState from './useMegaMenuMobileState';
import classNames from 'classnames';

const HeaderMobile = ({ headerModel, frontPageUrl, frontPageTitle }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const { menuExpanded, searchExpanded, selectedMain, selectedSub, setMenuExpanded, setSearchExpanded, setSelectedMain, setSelectedSub, } = useMegaMenuMobileState();

  const handleMenuClick = (evt) => {
    evt.preventDefault();
   
    setSearchExpanded(false);
    // on menu close
    if (menuExpanded === true) {
      setSelectedSub(null);
      setSelectedMain(null);
    }
    setMenuExpanded(val => !val);
  }

  const handleSearchIconClick = (evt) => {
    evt.preventDefault();

    setSearchExpanded(val => !val);
  }

  const handleSearchSubmit = (evt) => {
    evt.preventDefault();
   
    if (searchExpanded) {
      const url = new URL(`${window.location.origin}/searchpage`);
      url.searchParams.append("term", searchTerm);
      window.location.href = url.toString();
    }
  }

  const handleSearchInputChange = (evt) => {
    setSearchTerm(evt.target.value);
  }

  return (
    <div className='flex lg:hidden'>
      <div className={classNames('h-[120px] flex items-center justify-between px-[25px] pt-[50px] pb-[30px] fixed top-0 left-0 w-full z-10 transition-colors duration-300', menuExpanded ? 'bg-[#d3ecda]' : 'bg-white')}>
        <a className='mr-4' href={frontPageUrl} title={frontPageTitle}>
          <span className="h-full w-[200px] block">
            <LogoSvg />
          </span>
          <span className="sr-only">
            {frontPageTitle}
          </span>
        </a>
        <div className='flex items-center'>
          <button className='mr-4 border-none outline-none focus:border-none focus:outline-none' onClick={handleMenuClick}>
            { menuExpanded ?
              <CrossSvg className="h-6 w-6" />
              :
              <MenuSvg className="h-6 w-6" />
            }
          </button>
          { !menuExpanded && (
            <button className='border-none outline-none focus:border-none focus:outline-none' onClick={handleSearchIconClick}>
              { searchExpanded ?
                <CrossSvg className="h-6 w-6" />
                :
                <SearchRedesignSvg className="h-6 w-6" />
              }
            </button>
          )}
        </div>
        { searchExpanded && (
          <form 
            className='fixed top-[100px] left-0 w-full z-1 bg-gray-100 p-[16px] flex transition-colors duration-300 bg-[#f3f6f7]'
            onSubmit={handleSearchSubmit}
          >
            <label htmlFor="globalSearch" className="sr-only">{headerModel.searchAccessibilityText}</label>
            <div className='flex w-full bg-white'>
              <input 
                className='flex-grow p-4 border-none outline-none'
                onChange={handleSearchInputChange}
                placeholder={headerModel.searchPlaceholderText}
              />
              <button className='p-0 mr-[15px] border-none outline-none'>
                <span className="sr-only">{headerModel.searchAccessibilityText}</span>
                <SearchRedesignSvg className="h-6 w-6" />
              </button>
            </div>
          </form>
        )}
      </div>
      <MegaMenuMobile
        megaMenuModel={headerModel?.megaMenuModel}
        active={menuExpanded}
        selectedMain={selectedMain}
        selectedSub={selectedSub}
        setSelectedMain={setSelectedMain}
        setSelectedSub={setSelectedSub}
      />
    </div>
  )
}

export default HeaderMobile;